import t from '~t'
import React from 'react'
import { API_ENDPOINT_URL } from '~data/constants/app'
import sessionStorage from '~modules/sessionStorage'

import { Button, Separator, Icon } from '~ui';

export default function AccountSocialLogin({ disabled }) {
    const redirect = sessionStorage.getItem('redirect') || ''

    return (<>
        <Separator />
        {['google', 'apple'].map(vendor=>(
            <Button 
                key={vendor}
                className={vendor+' '+'ui-social-vendor'}
                variant='outline'
                disabled={disabled}
                data-block
                href={`${API_ENDPOINT_URL}auth/${vendor}?redirect=${encodeURIComponent(redirect)}`}>
                <Icon name={vendor} className={'ui-social-icon'} /> {t.s('signInSocial')} <span>{vendor}</span>
            </Button>
        ))}
    </>)
}